module.exports = __webpack_public_path__ + "img/img_weizhi.97b47508.jpg";